module.exports = __webpack_public_path__ + "static/media/admin-dashboard.88b73159.png";